module.exports = __webpack_public_path__ + "static/media/preferred_lang.a3f375c7.mp3";